/** Chaque type de portail dépend de son add-on effectif. */
export const TYPES_PORTAIL = {
    collectionneur: 'espace-collectionneur',
    deposant: 'espace-deposant',
};
export const ETATS_ACCES_EXTERNE = ['invite', 'actif', 'suspendu', 'revoque'];
import { z } from 'zod';
export const TYPES_PARTAGE_ESPACE = [
    'oeuvre',
    'facture',
    'facture_historique',
    'certificat',
    'conservation',
];
const identifiant = z.string().regex(/^[a-f\d]{24}$/i);
export const elementPartageEspaceSchema = z.strictObject({
    type: z.enum(TYPES_PARTAGE_ESPACE),
    cibleId: identifiant,
    exemplaireId: identifiant.optional(),
});
export const partageEspaceSchema = z.strictObject({
    elements: z.array(elementPartageEspaceSchema).min(1).max(100),
    prevenir: z.boolean().default(false),
});
const texteBilingue = (limite) => z.strictObject({
    fr: z.string().trim().max(limite).optional(),
    en: z.string().trim().max(limite).optional(),
});
export const conseilConservationSchema = z.strictObject({
    texte: texteBilingue(8000),
    version: z.number().int().min(0).optional(),
});
export const reglagesEspaceSchema = z.strictObject({
    accueil: texteBilingue(1000),
    formulaireContact: z.boolean(),
    version: z.number().int().min(0).optional(),
});
export const invitationEspaceSchema = z.strictObject({ langue: z.enum(['fr', 'en']).optional() });
export const gesteAccesEspaceSchema = z.strictObject({ version: z.number().int().min(1) });
export const gesteAccesMotiveEspaceSchema = gesteAccesEspaceSchema.extend({
    motif: z.string().trim().min(1).max(1000),
});
//# sourceMappingURL=espace-collectionneur.js.map